var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_vm._m(0),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-8 mx-auto py-4"},[_vm._t("default")],2)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row bg-primary"},[_c('div',{staticClass:"col-8 mx-auto py-3"},[_c('img',{attrs:{"src":"/assets/imgs/ae-logo-w-horizontal.png","height":"70"}})])])
}]

export { render, staticRenderFns }